import { Route, Outlet, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginPage from "../pages/login";
import { useAuthStore } from "../store/authStore";
import Cookies from "js-cookie";
import { verifyToken } from "../api/authAPI";
import { useMutation } from "@tanstack/react-query";

const GuardedRoute = () => {
  const { user, logout, setLoaderState } = useAuthStore((state) => state);
  const token = Cookies.get("access_token")
  const [isAuth, setIsAuth] = useState(false)

  const checkAuth = () => {
    if (user && token) {
      setIsAuth(true)
    } else {
      // window.location.reload()
      setLoaderState(false)
      Cookies.remove("access_token")
      logout();
      setIsAuth(false)
    }
  }

  const findToken = () => {
    return Cookies.get("access_token");
  };

  const [lastToken, setLastToken] = useState(findToken());
  const { addUser, setToken } = useAuthStore();
  const verifytoken = useMutation(verifyToken);
  useEffect(() => {
    console.log("last token", lastToken);
    if (lastToken !== undefined) {
      console.log("token found");

      verifytoken.mutate({ token: lastToken });
    }
  }, [lastToken]);
  useEffect(() => {
    if (verifytoken?.isSuccess && verifytoken?.data?.data?.success) {
      console.log("token verified => adding user");
      // add user to store
      addUser(verifytoken.data?.data?.data?.data);
      // set token to store
      setToken((verifytoken.data?.data?.data)?.token);
    }
  }, [verifytoken.data])




  useEffect(() => {
    checkAuth()
  }, [user, token])
  return (
    <>{isAuth ?
      <Outlet /> :
      <Routes>
        <Route path='*' element={<LoginPage />} />
      </Routes>
    }

    </>

  )
}

export default GuardedRoute;